import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProfileService, UiService } from 'core/services';

@Component({
  selector: 'lms-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit, OnDestroy {
  public profileSubscription: Subscription;
  navigationRoutes = [];
  menuContext: any[];

  constructor(public uiService: UiService, public profileService: ProfileService, public router: Router) {}

  ngOnInit() {
    this.menuContext = [];
    this.profileSubscription = this.profileService.getLoggedUser$().subscribe(() => {
      this.menuContext = [];
      this.setNavigationRoutes();
    });
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

  setNavigationRoutes() {
    this.navigationRoutes = this.profileService.getNavigationRoutes();
  }
}
